import { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Grid, TextField } from '@material-ui/core'
import { Add as AddIcon } from '@material-ui/icons'

import { Label, MenuButton } from 'components'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'
import helpers from 'helpers'

const PendingBillingEmails = ({
  emails,
  setEmails,
  title = 'E-mails de notificação',
}) => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')

  const handleAdd = () => {
    if (!helpers.formatters.isValidEmail(email)) {
      return setError('Informe um e-mail válido')
    }

    if (emails.includes(email)) {
      return setError('Este e-mail já foi adicionado')
    }

    setEmails([...emails, email])
    setEmail('')
    setError('')
  }

  const handleRemove = (emailToRemove) => {
    setEmails(emails.filter((currentEmail) => currentEmail !== emailToRemove))
  }

  return (
    <Label title={title} marginTopChildren={1}>
      <Grid container spacing={2}>
        <Grid item xs={10}>
          <TextField
            type="email"
            label="E-mail"
            fullWidth
            variant="outlined"
            value={email}
            error={!!error}
            helperText={error}
            onChange={(event) => setEmail(event.target.value)}
          />
        </Grid>
        <Grid item xs={2}>
          <Button
            fullWidth
            startIcon={<AddIcon />}
            variant="contained"
            color="primary"
            onClick={handleAdd}
            type="button"
          >
            Adicionar
          </Button>
        </Grid>
      </Grid>
      <Table size="small" emptyMessage="Nenhum e-mail adicionado">
        <TableHead>
          <TableRow>
            <TableCell width="80%">E-mail</TableCell>
            <TableCell width="20%" align="right">
              Ações
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {emails.map((currentEmail) => (
            <TableRow hover key={currentEmail}>
              <TableCell noOverFlow>{currentEmail}</TableCell>
              <TableCell disableTooltip align="right">
                <MenuButton>
                  <Button
                    onClick={() => handleRemove(currentEmail)}
                    fullWidth
                    size="small"
                    type="button"
                  >
                    Excluir
                  </Button>
                </MenuButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Label>
  )
}

PendingBillingEmails.propTypes = {
  emails: PropTypes.arrayOf(PropTypes.string).isRequired,
  setEmails: PropTypes.func.isRequired,
  title: PropTypes.string,
}

export default PendingBillingEmails
